<script lang="ts" setup>
defineProps({
  to: {
    required: true,
    type: String,
  },
})

const { t } = useI18n()
</script>

<template>
  <UTooltip :text="t('globals.showCompanies')">
    <ULink
      class="size-4.5 ml-2"
      :to="to"
    >
      <UIcon
        class="size-4.5 text-gray-500 transition hover:text-black dark:text-gray-500 dark:hover:text-white"
        :name="getIcon('search')"
      />
    </ULink>
  </UTooltip>
</template>
